const IOS_BROWSERS = /CriOS|FxiOS|EdgiOS|OPiOS|DuckDuckGo|Brave|GSA/i

export function shouldCopyMediaLink() {
  const ua = navigator.userAgent || ''
  if (/Android/i.test(ua)) {
    // WebViews also contain Chrome and Safari tokens; check their markers first.
    if (/\bwv\b|; wv\)|WebView|XWEB_/i.test(ua)) return true
    return !/Chrome\/|Firefox\/|SamsungBrowser\/|VivoBrowser|MiuiBrowser|HuaweiBrowser|EdgA\/|OPR\//i.test(ua)
  }

  const ios = /iPad|iPhone|iPod/i.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  if (!ios) return false
  // Safari and third-party browser apps identify themselves; a carrier WKWebView
  // normally has neither Safari nor a browser-specific token.
  return !/Safari\//i.test(ua) && !IOS_BROWSERS.test(ua)
}

export function saveMedia(url) {
  if (!url) return
  // OSS sets Content-Disposition: attachment on download_url. Do not set the
  // cross-origin <a download> attribute: it may be ignored by mobile browsers.
  window.location.assign(url)
}



// WEBPACK FOOTER //
// ./src/utils/mediaDownload.js